﻿/* eslint no-console: 0 */
const env = process.env.NODE_ENV;

export const getErrorMessage = (
  error,
  defaultMessage = 'Something went wrong',
) => {
  const data = error.response?.data;

  // A 5xx from Django is an HTML page rather than JSON, and indexing a string with
  // [0] returns its first character, so the chain below used to surface a toast
  // reading "<". Handle a string body separately, and discard it when it is markup
  // because there is nothing in an error page worth showing a user.
  if (typeof data === 'string') {
    const text = data.trim();
    return (
      (text.startsWith('<') ? '' : text) || error.message || defaultMessage
    );
  }

  return (
    data?.[0] ||
    data?.message ||
    // DRF's standard error body is {"detail": "..."} - notably what a 404 returns.
    // Without this the chain falls through to error.message, which is axios' generic
    // "Request failed with status code 404" and tells the user nothing.
    data?.detail ||
    // DRF's validation shape. The appointments 400 was exactly this:
    // {"non_field_errors": ["Expected a list of items but got type \"dict\"."]}
    data?.non_field_errors?.[0] ||
    // DRF keys field-level validation errors by field name, which is the most common
    // 400 the API returns and matched nothing above:
    //   {"subject": ["Select a valid choice. That choice is not one of ..."]}
    //   {"user": ["Select a valid choice. ..."]}
    // Those all fell through to axios' generic "Request failed with status code 400".
    // Take the first message from whichever field failed.
    firstFieldError(data) ||
    error.message ||
    defaultMessage
  );
};

function firstFieldError(data) {
  if (!data || typeof data !== 'object') {
    return undefined;
  }
  return Object.values(data)
    .flat()
    .find((value) => typeof value === 'string' && value.trim());
}

export function handleRSAAError(error) {
  if (env === 'production') {
    return;
  }

  const { name, message, status } = error;
  // Built mostly to elucidate API errors and to remind me of common issues
  console.log('RSAA Error: ', name);
  console.log(message);
  if (name === 'ApiError') {
    if (status === 400) {
      console.log('Check that the request is formatted to spec');
    } else if (status === 404) {
      console.log('Check that the API endpoint is correct');
    }
  }
}
